window.dataLayer = window.dataLayer || [];
const DEBUG = true; 
const log = (...msg) => DEBUG && console.log("[Yarbo Tracking]", ...msg);

// 防止 JS 被加载多次
if (window.__yarbo_tracking_installed) {
  log("Tracking already installed. Skip.");
  return;
}
window.__yarbo_tracking_installed = true;

/************************************************************
 *  UTIL – Map Item Structure
 ************************************************************/
function mapItem(item) {
  return {
    item_id: item.skuId || item.id,
    item_name: item.title || item.name,
    currency: item.currency || "AUD",
    price: Number(item.price) || Number(item.final_price / 100) || 0,
    quantity: Number(item.quantity) || 1
  };
}

/************************************************************
 *  VIEW ITEM（来自 window.__product）
 ************************************************************/
if (window.__product) {
  log("view_item fired");
  dataLayer.push({
    event: "view_item",
    items: [mapItem(window.__product)],
    currency: window.__product.currency,
    value: Number(window.__product.price)
  });
}

/************************************************************
 *  ADD TO CART（按钮点击版本）
 ************************************************************/
document.addEventListener("click", function (e) {
  const btn = e.target.closest("xo-cart-add button, button.xo-btn--primary");
  if (!btn) return;

  if (!window.__product) return;

  log("Button add_to_cart captured");

  pushAddToCart({
    item: mapItem(window.__product)
  });
});

/************************************************************
 * ADD TO CART（Fetch 拦截）
 ************************************************************/
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const url = args[0];

  const res = await originalFetch(...args);

  if (typeof url === "string" && url.includes("/cart/add")) {
    try {
      const json = await res.clone().json();
      if (json.items?.length) {
        const itm = json.items[0];

        log("Fetch add_to_cart captured");

        pushAddToCart({
          item: mapItem({
            id: itm.id,
            title: itm.title,
            price: itm.final_price,
            quantity: itm.quantity,
            currency: json.currency
          })
        });
      }
    } catch (e) {
      log("Fetch add_to_cart parse failed", e);
    }
  }

  return res;
};

/************************************************************
 * 统一 add_to_cart 方法（自动去重）
 ************************************************************/
let lastAddToCartTime = 0;

function pushAddToCart({ item }) {
  const now = Date.now();
  if (now - lastAddToCartTime < 300) {
    log("⛔阻止重复 add_to_cart");
    return; 
  }
  lastAddToCartTime = now;

  log("🔥 add_to_cart fired →", item);

  dataLayer.push({
    event: "add_to_cart",
    items: [item],
    currency: item.currency,
    value: item.price * item.quantity
  });
}

/************************************************************
 * REMOVE FROM CART（用于 /cart/change）
 ************************************************************/
window.fetch = new Proxy(window.fetch, {
  apply: async function (target, thisArg, args) {
    const url = args[0];
    const response = await target.apply(thisArg, args);

    if (typeof url === "string" && url.includes("/cart/change")) {
      try {
        const data = await response.clone().json();
        const removed = data.items?.filter(i => i.removed);

        if (removed?.length) {
          const item = removed[0];

          log("🔥 remove_from_cart fired");

          dataLayer.push({
            event: "remove_from_cart",
            items: [mapItem(item)],
            currency: "AUD",
            value: Number(item.price) || 0
          });
        }
      } catch (e) {
        log("remove_from_cart parse failed", e);
      }
    }

    return response;
  }
});

/************************************************************
 * BEGIN CHECKOUT（按钮点击）
 ************************************************************/
document.addEventListener("click", function (e) {
  const btn = e.target.closest("[name='checkout'], button[name='checkout']");
  if (!btn) return;

  if (!window.__cart) {
    log("begin_checkout ignored — missing window.__cart");
    return;
  }

  log("🔥 begin_checkout fired");

  dataLayer.push({
    event: "begin_checkout",
    currency: "AUD",
    value: window.__cart.total_price / 100,
    items: (window.__cart.items || []).map(mapItem)
  });
});

/************************************************************
 * OPTIONAL – 注入 user_id（如果你 GA4 用到）
 ************************************************************/
if (window.__user_id) {
  dataLayer.push({
    event: "user_data_detected",
    user_id: window.__user_id
  });

  log("User ID detected:", window.__user_id);
}
